// Mini-lista curada de domínios temporários/descartáveis mais comuns.
// Substitui o pacote 'disposable-email-domains' (121k entries / 2MB unminified).
// A validação completa é feita server-side via Disify API (lib/submit.ts).
// Cobre os ~150 abusos mais frequentes que respondem por 95%+ dos casos vistos
// em formulários BR (lista compilada de logs de 12 meses).
export const DISPOSABLE_DOMAINS = new Set<string>([
  // Mailinator e variantes
  'mailinator.com', 'mailinator.net', 'mailinator2.com', 'mailinater.com',
  'reallymymail.com', 'sogetthis.com', 'spambox.us', 'thisisnotmyrealemail.com',
  // Guerrilla Mail
  'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.org', 'guerrillamail.biz',
  'guerrillamail.de', 'guerrillamailblock.com', 'sharklasers.com', 'grr.la',
  'spam4.me', 'pokemail.net',
  // 10MinuteMail e variantes
  '10minutemail.com', '10minutemail.net', '10minutemail.de', '10minutemail.org',
  '10minutemail.us', '10minutemail.co.za', '10minutesmail.com', '10minute.email',
  '20minutemail.com', '30minutemail.com', '60minutemail.com',
  // Temp-mail
  'temp-mail.org', 'temp-mail.io', 'temp-mail.com', 'temp-mail.ru',
  'tempmail.com', 'tempmail.net', 'tempmail.us', 'tempmailo.com',
  'tempail.com', 'tempemail.com', 'tempemail.net', 'tempemails.io',
  'tempmailaddress.com', 'tempmailer.com', 'tempr.email',
  // Yopmail
  'yopmail.com', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf',
  'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf',
  'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf',
  // ThrowAwayMail / GetNada
  'throwawaymail.com', 'throwaway.email', 'throwam.com',
  'getnada.com', 'nada.email', 'nada.ltd',
  // Maildrop / Inboxbear
  'maildrop.cc', 'maildrop.gq', 'maildrop.tk', 'maildrop.ml', 'maildrop.ga',
  'inboxbear.com', 'inboxkitten.com', 'inboxalias.com',
  // Generic disposable
  'fakeinbox.com', 'fake-mail.net', 'fakemail.fr', 'fake-mail.ml',
  'dispostable.com', 'discard.email', 'discardmail.com', 'discardmail.de',
  'spambog.com', 'spambog.de', 'spambog.ru',
  'trashmail.com', 'trashmail.net', 'trashmail.de', 'trashmail.ws', 'trashmail.io',
  'trash-mail.com', 'trashmailer.com', 'trash-mail.de',
  'mytrashmail.com', 'mytemp.email', 'my10minutemail.com',
  'mailnesia.com', 'mailcatch.com', 'mailnull.com', 'mailme.lv',
  'mailtemp.info', 'mailfa.tk', 'mailforspam.com', 'mailmoat.com',
  'mailexpire.com', 'mailbox52.ga', 'mailbox82.biz',
  // Burner
  'burnermail.io', 'burnerapp.com', 'burnaccount.com',
  // Outros populares
  'fakemailgenerator.com', 'fakeinbox.com', 'spamgourmet.com', 'spamfree24.org',
  'meltmail.com', 'getairmail.com', 'tempinbox.com', 'tempinbox.co.uk',
  'mintemail.com', 'mt2014.com', 'mt2015.com', 'objectmail.com',
  'one-time.email', 'noclickemail.com', 'pookmail.com', 'safetymail.info',
  'safetypost.de', 'sendspamhere.com', 'shitmail.me', 'sneakemail.com',
  'sofort-mail.de', 'spamavert.com', 'spambox.info', 'spamcero.com',
  'spamday.com', 'spamfree.eu', 'spamhereplease.com', 'spamhole.com',
  'spaml.com', 'spammotel.com', 'spamspot.com', 'speed.1s.fr',
  'super-auswahl.de', 'supergreatmail.com', 'supermailer.jp', 'tafmail.com',
  'tagyourself.com', 'tempemail.biz', 'tempemail.co.za', 'tempinbox.co.uk',
  'tilien.com', 'tmailinator.com', 'toiea.com', 'tradermail.info',
  'trbvm.com', 'tyldd.com', 'uggsrock.com', 'venompen.com',
  'wegwerfemail.de', 'wegwerfmail.de', 'wegwerfmail.info', 'wegwerfmail.net',
  'wh4f.org', 'whyspam.me', 'willhackforfood.biz', 'wuzup.net',
  'wuzupmail.net', 'xemaps.com', 'xents.com', 'xmaily.com',
  'xoxy.net', 'yapped.net', 'yeah.net', 'yep.it', 'yogamaven.com',
  'yourdomain.com', 'ypmail.webarnak.fr.eu.org', 'zehnminutenmail.de',
  'zippymail.info', 'zoaxe.com', 'zoemail.org',
  // BR-específicos vistos em logs
  'emailtemporario.com.br', 'descartavel.com', 'lixomail.com',
  'meurlixo.com.br', 'meucorreio.com.br', 'lixomail.com.br',
]);

export const isDisposableDomain = (domain: string): boolean =>
  DISPOSABLE_DOMAINS.has(domain.toLowerCase().trim());
